import { useRouter } from "next/router";
import useSWRImmutable from "swr/immutable";
import { Country } from "../../features/set-up-spaces-flow/models";
import fetcher from "./fetcher";

export const useCountries = () => {
    const router = useRouter();

    const { data = [], isLoading } = useSWRImmutable(
        ["/api/static-data/v1/countries", router.locale],
        ([url]) => fetcher(url)
    );

    return {
        countries: data as Country[],
        isLoadingCountries: isLoading,
    };
};
